import { throttle } from 'lodash';
import { useEffect, useState } from 'react';

interface Props {
  onResize?: () => void;
}

type ResolutionInfo = {
  isMobile: boolean;
  isTablet: boolean;
  isDesktop: boolean;
  screenWidth: number;
  screenHeight: number;
};

const MOBILE_BP = 480;
const TABLET_BP = 900;

const getResolutionInfo = (): ResolutionInfo => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;

  const isMobile = screenWidth <= MOBILE_BP;
  const isTablet = screenWidth > MOBILE_BP && screenWidth <= TABLET_BP;
  const isDesktop = screenWidth > TABLET_BP;

  return {
    screenWidth,
    screenHeight,
    isMobile,
    isTablet,
    isDesktop,
  };
};

const useResolutionInfo = (props?: Props): ResolutionInfo => {
  const [resolutionInfo, setResolutionInfo] = useState(getResolutionInfo);

  useEffect(() => {
    const handleResize = throttle(() => {
      const resolutionInfo = getResolutionInfo();
      setResolutionInfo(resolutionInfo);
      props?.onResize?.();
    }, 200);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return resolutionInfo;
};

export { useResolutionInfo, getResolutionInfo };
